// import { sortString, sortNumber, toSearchableString } from 'app/utils';
import dateFns from 'date-fns';
import _ from 'lodash';

const TEMPLATE_NAME = 'DASHBOARD';

const VISITS_TYPE = {
    1: {},
    2: {
        table: 'nurse',
    },
    3: {
        table: 'doctor',
    },
};
// const sort = function (a, b) {
//     let result = sortNumber(b.status, a.status);
//     if (result !== 0) {
//         return result;
//     }
//     const aName = a.name || null;
//     const bName = b.name || null;
//     result = sortString(aName, bName);
//     if (result !== 0) {
//         return result;
//     }
//     return sortString(a.key, b.key);
// };

const SORT_VISIT_PLANNED = (a, b) => {
    const sort = dateFns.compareDesc(a.start, b.start);

    if(sort === 0) {
        return dateFns.compareDesc(a.arrivalDate, b.arrivalDate);
    }

    return sort;
};

const SORT_VISIT_COMPLETED = (a, b) => {
    return dateFns.compareDesc(a.end, b.end);
};


const filterTable = term => e => {
    const { doctor, nurse, patient } = e;
    if (doctor) {
        return doctor.name.toLowerCase().indexOf(term.toLowerCase()) !== -1 || patient.name.toLowerCase().indexOf(term.toLowerCase()) !== -1;
    } else if (nurse) {
        return nurse.name.toLowerCase().indexOf(term.toLowerCase()) !== -1 || patient.name.toLowerCase().indexOf(term.toLowerCase()) !== -1;
    }
    return false;
};

// const filterMap = term => e => {
//     return e.name.toLowerCase().indexOf(term.toLowerCase()) !== -1;
// };

// const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const getAppointement = () => {
    return {
        index: 0,
        times: [
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 9, 0, 0),
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 11, 0, 0),
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 13, 0, 0),
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 15, 0, 0),
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 16, 0, 0),
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 18, 0, 0),
        ]
    };
};

const setAppointement = data => {
    let { planned, doctor, nurse } = data;
    let { visitationByDoctor } = doctor;
    let { visitationByNurse } = nurse;

    const marcados = {};

    planned = planned.map(row => {
        if ('nurse' in row){
            const employee = row.nurse;
            if (!marcados[employee.id]) {
                marcados[employee.id] = getAppointement();
            }

            row.appointment = marcados[employee.id].times[marcados[employee.id].index++];

            visitationByNurse[employee.id].visits = visitationByNurse[employee.id].visits.map(v => {
                if (v.id === row.id) {
                    v.appointment = row.appointment;
                }

                return v;
            });
            
        } else if ('doctor' in row) {
            const employee = 'nurse' in row ? row.nurse : row.doctor;
            if (!marcados[employee.id]) {
                marcados[employee.id] = getAppointement();
            }

            row.marcado = marcados[employee.id].times[marcados[employee.id].index++];

            visitationByDoctor[employee.id].visits = visitationByDoctor[employee.id].visits.map(v => {
                if (v.id === row.id) {
                    v.appointment = row.appointment;
                }

                return v;
            });
        }

        return row;
    });

    data.doctor.visitationByDoctor = visitationByDoctor;
    data.nurse.visitationByNurse = visitationByNurse;
    data.planned = planned;

    return data;
};

const filterData = (data, term, type) => {
    let filtered = Object.assign({}, data);
    if (!_.isEmpty(type)) {
        for (let t of type) {
            if (VISITS_TYPE[t].table) {
                filtered.planned = data.planned.filter(v => ((VISITS_TYPE[t].table in v)));
                filtered.completed = data.completed.filter(v => ((VISITS_TYPE[t].table in v)));
            }
        }
    }

    if (!_.isEmpty(term)) {
        filtered.planned = data.planned.filter(filterTable(term));
        filtered.completed = data.completed.filter(filterTable(term));
        // filtered.nurses = data.nurses.filter(filterMap(term));
        // filtered.doctors = data.doctors.filter(filterMap(term));
        // filtered.patients = data.patients.filter(filterMap(term));
    }

    filtered.planned.sort(SORT_VISIT_PLANNED);
    filtered.completed.sort(SORT_VISIT_COMPLETED);

    filtered = setAppointement(filtered);
    return filtered;
};

const initialState = () => ({
    loading: false,
    autoUpdate: true,
    toggle: false,
    data: [],
    filter: {
        term: '',
        type: [],
        data: [],
    },
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;
            return {
                ...state,
                loading: false,
                data: data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_UPDATE_AUTO_UPDATE`: {
            return {
                ...state,
                autoUpdate: action.payload,
            };
        }
        case `${TEMPLATE_NAME}_SEARCH`: {
            const term = action.payload;
            return {
                ...state,
                filter: {
                    ...state.filter,
                    term,
                    data: filterData(state.data, term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_FILTER`: {
            const type = action.payload;
            return {
                ...state,
                filter: {
                    ...state.filter,
                    type,
                    data: filterData(state.data, state.filter.term, type),
                },
            };
        }
        case `${TEMPLATE_NAME}_SIDEBAR`: {
            const toggle = action.payload;
            return {
                ...state,
                toggle,
                filter: {
                    ...state.filter,
                    data: filterData(state.data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_UPDATE`: {
            const updatedRow = action.payload;
            const data = state.data.map(row => (row.idCliente === updatedRow.idCliente ? updatedRow : row));
            return {
                ...state,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_DELETE`: {
            const deletedId = action.payload;
            const data = state.data.filter(data => data.idCliente !== deletedId);

            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_CREATE`: {
            const newRow = action.payload;
            const data = [...state.data, newRow];
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term, state.filter.type),
                },
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};
export default reducer;